// Γραμματοσειρές QR Menu (όλες με ελληνική υποστήριξη, Google Fonts)
export const QRMENU_FONTS = [
  "GFS Didot",
  "Open Sans",
  "Roboto Slab",
  "Ubuntu",
  "Comfortaa",
  "Advent Pro",
  "Play",
  "Noto Serif",
];

const GF_URL =
  "https://fonts.googleapis.com/css2?" +
  [
    "family=GFS+Didot",
    "family=Open+Sans:ital,wght@0,400;0,700;1,400;1,700",
    "family=Roboto+Slab:wght@400;700",
    "family=Ubuntu:ital,wght@0,400;0,700;1,400;1,700",
    "family=Comfortaa:wght@400;700",
    "family=Advent+Pro:ital,wght@0,400;0,700;1,400;1,700",
    "family=Play:wght@400;700",
    "family=Noto+Serif:ital,wght@0,400;0,700;1,400;1,700",
  ].join("&") +
  "&display=swap";

export function loadQrMenuFonts() {
  if (document.getElementById("qrmenu-fonts")) return;
  const link = document.createElement("link");
  link.id = "qrmenu-fonts";
  link.rel = "stylesheet";
  link.href = GF_URL;
  document.head.appendChild(link);
}

export const lineStyle = (l) => ({
  fontFamily: `'${l.font}', serif`,
  fontWeight: l.bold ? 700 : 400,
  fontStyle: l.italic ? "italic" : "normal",
});
